import { lazy } from 'solid-js';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';

export const LtlQuoteShell = lazy(() => import('./LtlQuoteShell'));
export const isAllowInsuranceDeletion = () => {
  return isFeatureFlagEnabled(FeatureFlags.AllowInsuranceDeletion)();
};
